export const AUTH_LOGIN_TARGETS = Object.freeze({
  admin: 'admin',
  parent: 'parent',
  student: 'student',
});

export const AUTH_LOGIN_ROUTE_PREFIX = '/sign-in';

const legacyTargetAliases = Object.freeze({
  login: AUTH_LOGIN_TARGETS.student,
  user: AUTH_LOGIN_TARGETS.student,
});

export function normalizeAuthLoginTarget(value = '') {
  const normalized = String(value || '').replace(/^#/, '').trim().toLowerCase();
  if (AUTH_LOGIN_TARGETS[normalized]) {
    return normalized;
  }
  return legacyTargetAliases[normalized] || '';
}

export function authLoginHashForTarget(value = AUTH_LOGIN_TARGETS.student) {
  return normalizeAuthLoginTarget(value) || AUTH_LOGIN_TARGETS.student;
}

export function authLoginTargetFromHash(hash = '') {
  return normalizeAuthLoginTarget(hash);
}

export function authLoginPathForTarget(value = AUTH_LOGIN_TARGETS.student) {
  return `${AUTH_LOGIN_ROUTE_PREFIX}/${authLoginHashForTarget(value)}`;
}

export function authLoginTargetFromPathname(pathname = '') {
  const parts = String(pathname || '').split('/').filter(Boolean);
  const signInIndex = parts.indexOf(AUTH_LOGIN_ROUTE_PREFIX.replace('/', ''));
  if (signInIndex < 0) {
    return '';
  }
  return normalizeAuthLoginTarget(parts[signInIndex + 1] || '');
}

export function authLoginTargetFromLocation(pathname = '', hash = '') {
  return authLoginTargetFromPathname(pathname) || authLoginTargetFromHash(hash);
}
